//const api = "http://127.0.0.1:8000/api/";
const api = "https://backidb.medikoala.com/api/";
export default api;